import _ from 'lodash';
import Service from './abstract';
import page from '../constants/pages/page';

const defaultWith = 'type,attributes,attributes.attribute';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith,
    pageSize: page.pageSize
};

const basePath = '/settings';

class Settings extends Service {
    constructor () {
        super('settings');
    }

    get fullWith () {
        return defaultWith;
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    getProducts (options = {}) {
        return this.get({
            url: `${basePath}/settings/recharges/products`,
            qs: _.defaultsDeep({ tiny: false }, options)
        });
    }
}

export default new Settings();
